<template>
    <div>
        <img src="/img/zuerioberland_titelseite_sternenberg.webp" class="max-h-[85vh] w-full object-cover pt-24 md:pt-0" />
        <div class="max-w-7xl m-auto py-12 md:py-16 px-5 md:px-0">
            <h1 class="text-2xl pb-5">Willkommen bei echtregional.</h1>
            <p>
                Die 2023 lancierte Plattform ermöglicht die digitale Zertifizierung Schweizer
                Regionalprodukte. Somit kann der Prozess über alle Stufen von der Produktion über die
                Regionalmarken bis zu den unabhängigen Zertifizierungsstellen in einem gemeinsamen
                System und fast komplett papierlos erfolgen. Er wird dadurch professionalisiert, für alle
                Benutzer:innen vereinfacht, zentralisiert und digitalisiert. Das spart Zeit und Geld.
                <br />
                Schweizweit wurden im Jahr 2022 rund 10’000 Produkte nach den Richtlinien für Schweizer
                Regionalprodukte hergestellt. Durch die Skalierbarkeit können mittels Mandantenfunktion
                schweizweit alle Produkte unter dem einheitlichen Label regio.garantie über dieses System
                laufen!
            </p>
            <p class="pt-6">
                Möchten Sie ebenfalls von diesem System profitieren? Dann melden Sie sich bei der
                Initiantin des Projektes, der Standortförderung Zürioberland unter 
                <a href="mailto:info@zuerioberland.ch">info@zuerioberland.ch</a>
                oder <a href="tel:+41 52 396 59 90">+41 52 396 59 90</a>. Wir freuen uns, von Ihnen zu hören.
            </p>
        </div>
    </div>
</template>